export enum XAppOrigin {
  iOS = 'IOS',
  Android = 'ANDROID',
  Web = 'WEB',
  Kiosk = 'KIOSK',
  POS = 'POS',
  PartnerAPI = 'PARTNER_API',
}
